import { render, staticRenderFns } from "./MatchBrandList.vue?vue&type=template&id=bb965bc8&scoped=true&"
import script from "./MatchBrandList.vue?vue&type=script&lang=js&"
export * from "./MatchBrandList.vue?vue&type=script&lang=js&"
import style0 from "./MatchBrandList.vue?vue&type=style&index=0&id=bb965bc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb965bc8",
  null
  
)

export default component.exports